import { HATO_HEART_PATHS, getPathHatoHeart } from './paths'

export const HATO_HEART_ROUTES = {
  HOME: getPathHatoHeart(HATO_HEART_PATHS.HOME),
  REDIRECT_HH_TO_LIFF: getPathHatoHeart(HATO_HEART_PATHS.REDIRECT_HH_TO_LIFF),
  BURN_POINTS: getPathHatoHeart(HATO_HEART_PATHS.BURN_POINTS),
  COUPONS: getPathHatoHeart(HATO_HEART_PATHS.COUPONS),
  FEEDBACK: getPathHatoHeart(HATO_HEART_PATHS.FEEDBACK),
  TRANSACTIONS: getPathHatoHeart(HATO_HEART_PATHS.TRANSACTIONS),
} as const
